// Using CJS instead of ESM because test-backend is failing when integrated to FEBE.
const { createStitches } = require('@stitches/react');

const {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
  config,
} = createStitches({
  // Other configurations can be found here. https://stitches.dev/docs/api#createstitches
  media: {
    mobile: '(min-width: 320px)',
    tablet: '(min-width: 768px)',
    desktop: '(min-width: 1024px)',
  },
  utils: {
    marginX: (value) => ({ marginLeft: value, marginRight: value }),
    marginY: (value) => ({ marginTop: value, marginBottom: value }),
    size: (width, height) => ({ width, height }),
  },
  prefix: 'pf-comp-lib',
  theme: {
    colors: {
      narwhal500: '#557b92',
      denim500: '#113b5e',
    },
    fonts: {
      title1: `"Neue Haas Grotesk Display Bold", "Helvetica Neue", helvetica, arial, sans-serif`,
      body: `"Neue Haas Grotesk Text Regular", "Helvetica Neue", helvetica, arial, sans-serif`,
    },
    fontSizes: {
      1: '12px',
      2: '14px',
      3: '16px',
      4: '18px',
      5: '20px',
      6: '24px',
      7: '28px',
      8: '36px',
    },
    lineHeights: {
      1: '16px',
      2: '20px',
      3: '24px',
      4: '28px',
      5: '32px',
      6: '36px',
      7: '40px',
    },
    fontWeights: {
      1: '400',
    },
  },
});

const mixins = {
  body: {
    '@mobile': {
      fontFamily: '$body',
      fontSize: '$3',
      lineHeight: '$3',
    },
    '@desktop': {
      fontSize: '$4',
      lineHeight: '$4',
    },
  },
  title1: {
    '@mobile': {
      fontFamily: '$title1',
      fontSize: '$6',
      lineHeight: '$4',
    },
    '@tablet': {
      fontSize: '$7',
      lineHeight: '$5',
    },
    '@desktop': {
      fontSize: '$8',
      lineHeight: '$7',
    },
  },
  title2: {
    '@mobile': {
      fontFamily: '$title1',
      fontSize: '$4',
      lineHeight: '22px',
    },
    '@tablet': {
      fontSize: '$5',
      lineHeight: '$3',
    },
    '@desktop': {
      fontSize: '$6',
      lineHeight: '$4',
    },
  },
};

module.exports = {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
  config,
  mixins,
};

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan-v2/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');